/* eslint-disable max-len */
import React from 'react';

export const facebook = (color = 'rgba(125,125,125, 0.5)', filled = true, width = 25, height = 25) => (
  <svg width={width} height={height} viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.5 0h-13C1.1 0 0 1.1 0 2.5v13C0 16.9 1.1 18 2.5 18h13c1.4 0 2.5-1.1 2.5-2.5v-13C18 1.1 16.9 0 15.5 0zM15 8.3v2.2h-3V18H9.8v-7.5H8.3V8.3h1.5V5.8c0-1.6.8-2.8 2.7-2.8H15v2.2h-2.3c-.6 0-.7.3-.7.6v2.4h3z'
      fillRule='evenodd'
      clipRule='evenodd'
      fill={filled ? color : 'none'}
    />
  </svg>
);
